<template>
	<div>
		<case-form :schema="schema" class="mt6" />
		<case-form :schema="schemaOther" class="mt6" />
		<div class="xs-12 fs4 fw7 mb2 mt6">If yes, please provide details</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Alternate Residence</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form
					:schema="schemaAlternateResidenceAddress(i)"
					:isBoxed="false"
				/>
			</div>
		</j-accordion>
		<case-form :schema="schemaHasProperty" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">
			If “Yes,” please give full address of each and amount of time spent there
			each year:
		</div>
		<j-accordion
			v-for="i in numOfPropertyFields"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Additional Property</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaPropertyList(i)" :isBoxed="false" />
			</div>
		</j-accordion>
		<case-form :schema="schemasHasRightOfAbode" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">
			If “Yes,” please state the country and amount of time spent there each
			year:
		</div>
		<j-accordion
			v-for="i in numOfResidencyFields"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Residency Status</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaRightOfAbodeList(i)" :isBoxed="false" />
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	data() {
		return {
			numOfPropertyFields: 3,
			numOfResidencyFields: 3
		}
	},

	computed: {
		schema() {
			return [
				{
					label: "Insured",
					component: "entitySelect",
					bindTo: "case.insureds[0]",
					entity: "case.insureds[0]",
					props: {
						allowedEntityTypes: ["individual"]
					}
				},
				{
					label: "Title",
					component: "entityField",
					entity: "case.insureds[0]",
					fieldToUpdate: "salutation",
					props: {
						updateOptions: {
							component: "select",
							props: {
								options: [
									{
										name: "Mr",
										value: "Mr"
									},
									{
										name: "Mrs",
										value: "Mrs"
									},
									{
										name: "Miss",
										value: "Miss"
									},
									{
										name: "Other",
										value: "Other"
									}
								]
							}
						}
					}
				},
				{
					label: "Other Titles",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherTitles`,
					props: {
						suggest: {
							typeIncludes: `otherTitles`
						},
						createOptions: {
							type: `otherTitles`,
							dataType: "string"
						}
					}
				},
				{
					label: "Suffix",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0suffix`,
					props: {
						suggest: {
							typeIncludes: `suffix`
						},
						createOptions: {
							type: `suffix`,
							dataType: "string"
						}
					}
				},
				{
					label:
						"Are you/have you been known under any Former Name, Maiden Name or Alias?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasFormerNameOrAlias`,
					props: {
						suggest: {
							typeIncludes: `hasFormerNameOrAlias`
						},
						createOptions: {
							type: `hasFormerNameOrAlias`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If “Yes,” please provide the other names below",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0formerNameOrAlias`,
					props: {
						suggest: {
							typeIncludes: `formerNameOrAlias`
						},
						createOptions: {
							type: `formerNameOrAlias`,
							dataType: "string"
						}
					}
				},
				{
					label: "Date Of Birth",
					component: "entityField",
					entity: "case.insureds[0]",
					fieldToUpdate: "dateOfBirth",
					props: {
						updateOptions: {
							component: "date"
						}
					}
				},
				{
					label: "City Of Birth",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0cityOfBirth`,
					props: {
						suggest: {
							typeIncludes: `cityOfBirth`
						},
						createOptions: {
							type: `cityOfBirth`,
							dataType: "string"
						}
					}
				},
				{
					label: "Country Of Birth",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0countryOfBirth`,
					props: {
						suggest: {
							typeIncludes: `countryOfBirth`
						},
						createOptions: {
							type: `countryOfBirth`,
							dataType: "string"
						}
					}
				},
				{
					label: "Countries of Citizenship",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0countriesOfCitizenship`,
					props: {
						suggest: {
							typeIncludes: `countriesOfCitizenship`
						},
						createOptions: {
							type: `countriesOfCitizenship`,
							dataType: "string"
						}
					}
				},
				{
					label: "Current Address",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0permanentReisdentAddress",
					props: {
						suggest: {
							typeIncludes: "permanentReisdentAddress"
						},
						createOptions: {
							type: "permanentReisdentAddress"
						}
					}
				},
				{
					label: "Mailing Address (if different from above)",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0mailingAddress",
					props: {
						suggest: {
							typeIncludes: "mailingAddress"
						},
						createOptions: {
							type: "mailingAddress"
						}
					}
				},
				{
					label: "How long have you lived at the present address? (Years)",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0durationAtPresentAddress`,
					props: {
						suggest: {
							typeIncludes: `durationAtPresentAddress`
						},
						createOptions: {
							type: `durationAtPresentAddress`,
							dataType: "number"
						}
					}
				},
				{
					label: "If yes, did you live in a different country?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasLivedInOtherCountries`,
					props: {
						suggest: {
							typeIncludes: `hasLivedInOtherCountries`
						},
						createOptions: {
							type: `hasLivedInOtherCountries`,
							dataType: "boolean"
						}
					}
				},
				{
					label: "If “Yes,” which countries",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0previousCountryOfResidence`,
					props: {
						suggest: {
							typeIncludes: `previousCountryOfResidence`
						},
						createOptions: {
							type: `previousCountryOfResidence`,
							dataType: "string"
						}
					}
				},
				{
					label: "Home Number",
					component: "entityContact",
					entity: "case.holder",
					relation: "case.insureds[0].contacts",
					bindTo: "case.facts.insured0homeNumber",
					props: {
						suggest: {
							typeIncludes: `homeNumber`
						},
						createOptions: {
							type: `homeNumber`,
							dataType: "string"
						}
					}
				},
				{
					label: "Business Number",
					component: "entityContact",
					entity: "case.holder",
					relation: "case.insureds[0].contacts",
					bindTo: "case.facts.insured0businessNumber",
					props: {
						suggest: {
							typeIncludes: `businessNumber`
						},
						createOptions: {
							type: `businessNumber`,
							dataType: "string"
						}
					}
				},
				{
					label: "Fax Number",
					component: "entityContact",
					entity: "case.holder",
					relation: "case.insureds[0].contacts",
					bindTo: "case.facts.insured0faxNumber",
					props: {
						suggest: {
							typeIncludes: `faxNumber`
						},
						createOptions: {
							type: `faxNumber`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaOther() {
			return [
				{
					label:
						"Do you currently have more than one residence, or in the past 10 years have you had a second residence?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasMoreThanOneResidence`,
					props: {
						suggest: {
							typeIncludes: `hasMoreThanOneResidence`
						},
						createOptions: {
							type: `hasMoreThanOneResidence`,
							dataType: "boolean"
						}
					}
				}
			]
		},
		schemaHasProperty() {
			return [
				{
					label:
						"Do you own additional residential properties (vacation home, second home, time share, etc.)?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasAdditionalResidentialProperties`,
					props: {
						suggest: {
							typeIncludes: `hasAdditionalResidentialProperties`
						},
						createOptions: {
							type: `hasAdditionalResidentialProperties`,
							dataType: "boolean"
						}
					}
				}
			]
		},
		schemasHasRightOfAbode() {
			return [
				{
					label:
						"Do you hold a current passport, visa, or have permanent resident status in any country other than listed above?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasRightOfAbode`,
					props: {
						suggest: {
							typeIncludes: `hasRightOfAbode`
						},
						createOptions: {
							type: `hasRightOfAbode`,
							dataType: "boolean"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaAlternateResidenceAddress(i) {
			return [
				{
					label: "Address",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.insureds[0].addresses",
					bindTo: `case.facts.insured0alternateResidenceAddress${i}`,
					props: {
						suggest: {
							typeIncludes: `alternateResidenceAddress${i}`
						},
						createOptions: {
							type: `alternateResidenceAddress${i}`
						}
					}
				},
				{
					label: `Months/Years at this residence`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0alternateResidenceTimeSpent${i}`,
					props: {
						suggest: {
							typeIncludes: `alternateResidenceTimeSpent${i}`
						},
						createOptions: {
							type: `alternateResidenceTimeSpent${i}`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaPropertyList(i) {
			return [
				{
					label: `Property Purpose`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0residentialPropertyPurpose${i}`,
					props: {
						suggest: {
							typeIncludes: `residentialPropertyPurpose${i}`
						},
						createOptions: {
							type: `residentialPropertyPurpose${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: "Address",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.insureds[0].addresses",
					bindTo: `case.facts.insured0residentialPropertyAddress${i}`,
					props: {
						suggest: {
							typeIncludes: `residentialPropertyAddress${i}`
						},
						createOptions: {
							type: `residentialPropertyAddress${i}`
						}
					}
				},
				{
					label: `Amount of Time Spent There Each Year`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0residentialPropertyTimeSpent${i}`,
					props: {
						suggest: {
							typeIncludes: `residentialPropertyTimeSpent${i}`
						},
						createOptions: {
							type: `residentialPropertyTimeSpent${i}`,
							dataType: "string"
						}
					}
				}
			]
		},
		schemaRightOfAbodeList(i) {
			return [
				{
					label: `Country`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0rightOfAbodeCountry${i}`,
					props: {
						suggest: {
							typeIncludes: `rightOfAbodeCountry${i}`
						},
						createOptions: {
							type: `rightOfAbodeCountry${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Passport, Visa or Permanent Resident Status`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0rightOfAbodeDocumentStatus${i}`,
					props: {
						suggest: {
							typeIncludes: `rightOfAbodeDocumentStatus${i}`
						},
						createOptions: {
							type: `rightOfAbodeDocumentStatus${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Amount of Time Spent There Each Year`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0rightOfAbodeTimeSpent${i}`,
					props: {
						suggest: {
							typeIncludes: `rightOfAbodeTimeSpent${i}`
						},
						createOptions: {
							type: `rightOfAbodeTimeSpent${i}`,
							dataType: "string"
						}
					}
				}
			]
		}
	},

	mounted() {
		console.log("mounted")
	}
}
</script>
